import React from 'react'
import { Trans } from '@lingui/react'

import ModalTopBar from '../../layout/ModalTopBar'
import Modal, { ModalMainContainer } from '../../layout/Modal'
import ModalConfirmButtonBar from '../../layout/ModalConfirmButtonBar'
import TenantSelectionImpersonationForm from './TenantSelectionImpersonationForm'

const TenantSelectionImpersonationModal = ({
    formState,
    onClose,
    onSubmit,
    isSubmitting,
}) => (
    <Modal ariaLabel="Remote support reason">
        <ModalTopBar
            title={<Trans id="Enter the reason for remote support" />}
            onClose={onClose}
        />
        <ModalMainContainer>
            <TenantSelectionImpersonationForm formState={formState} />
        </ModalMainContainer>
        <ModalConfirmButtonBar
            isSubmitting={isSubmitting}
            onCancel={onClose}
            onSubmit={onSubmit}
        />
    </Modal>
)

export default TenantSelectionImpersonationModal
